/* eslint-disable import/prefer-default-export */
export const useHome = {
  width: 822, // 首页内容区宽度
  ideaListWidth: 976, // PPT灵感列表宽度
  marginTop: 66, // 首页顶部外边距
}
